// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.store-performance {
    background: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.store-performance h2 {
    font-size: 1.5rem;
    color: #333;
    margin: 0 0 20px 0;
    font-weight: 600;
}

.store-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

.store-card {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
}

.store-header {
    background-color: #f8f9fa;
    padding: 15px 20px;
    border-bottom: 1px solid #e0e0e0;
}

.store-header h3 {
    margin: 0 0 10px 0;
    font-size: 1.2rem;
    color: #333;
}

.country-tabs {
    display: flex;
    gap: 10px;
}

.tab {
    padding: 6px 12px;
    border: 1px solid #dee2e6;
    background: white;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.3s ease;
}

.tab.active {
    background-color: #007bff;
    color: white;
    border-color: #007bff;
}

.tab:hover:not(.active) {
    background-color: #f8f9fa;
}

.store-content {
    padding: 20px;
}

.app-info {
    margin-bottom: 20px;
}

.app-title {
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;
}

.metrics-bar {
    display: flex;
    gap: 15px;
    font-size: 12px;
    color: #666;
}

.metrics-bar span {
    padding: 4px 8px;
    background-color: #f8f9fa;
    border-radius: 4px;
}

.downloads-info {
    margin-bottom: 20px;
}

.total-downloads {
    text-align: left;
}

.total-downloads span {
    font-size: 11px;
    color: #666;
    display: block;
    margin-bottom: 5px;
}

.downloads-number {
    font-size: 2rem;
    font-weight: bold;
    color: #333;
}

.chart-container {
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.chart-title {
    font-size: 14px;
    color: #333;
    margin-bottom: 15px;
}

@media (max-width: 1024px) {
    .store-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .store-performance {
        padding: 15px;
    }

    .store-content {
        padding: 15px;
    }

    .metrics-bar {
        flex-wrap: wrap;
        gap: 8px;
    }

    .chart-container {
        height: 200px;
    }
}

.scroll-x {
    overflow-x: auto;
    white-space: nowrap;
}
.scroll-x .tab {
    display: inline-block;
    margin-right: 8px;
}
.app-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: bold;
    font-size: 16px;
}

.app-icon {
    width: 24px;
    height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/css/StorePerformance.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".store-performance {\r\n    background: white;\r\n    border-radius: 8px;\r\n    padding: 20px;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n\r\n.store-performance h2 {\r\n    font-size: 1.5rem;\r\n    color: #333;\r\n    margin: 0 0 20px 0;\r\n    font-weight: 600;\r\n}\r\n\r\n.store-grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 20px;\r\n}\r\n\r\n.store-card {\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n}\r\n\r\n.store-header {\r\n    background-color: #f8f9fa;\r\n    padding: 15px 20px;\r\n    border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.store-header h3 {\r\n    margin: 0 0 10px 0;\r\n    font-size: 1.2rem;\r\n    color: #333;\r\n}\r\n\r\n.country-tabs {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.tab {\r\n    padding: 6px 12px;\r\n    border: 1px solid #dee2e6;\r\n    background: white;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.tab.active {\r\n    background-color: #007bff;\r\n    color: white;\r\n    border-color: #007bff;\r\n}\r\n\r\n.tab:hover:not(.active) {\r\n    background-color: #f8f9fa;\r\n}\r\n\r\n.store-content {\r\n    padding: 20px;\r\n}\r\n\r\n.app-info {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.app-title {\r\n    font-size: 14px;\r\n    color: #333;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.metrics-bar {\r\n    display: flex;\r\n    gap: 15px;\r\n    font-size: 12px;\r\n    color: #666;\r\n}\r\n\r\n.metrics-bar span {\r\n    padding: 4px 8px;\r\n    background-color: #f8f9fa;\r\n    border-radius: 4px;\r\n}\r\n\r\n.downloads-info {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.total-downloads {\r\n    text-align: left;\r\n}\r\n\r\n.total-downloads span {\r\n    font-size: 11px;\r\n    color: #666;\r\n    display: block;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.downloads-number {\r\n    font-size: 2rem;\r\n    font-weight: bold;\r\n    color: #333;\r\n}\r\n\r\n.chart-container {\r\n    height: 250px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.chart-title {\r\n    font-size: 14px;\r\n    color: #333;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n    .store-grid {\r\n        grid-template-columns: 1fr;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .store-performance {\r\n        padding: 15px;\r\n    }\r\n\r\n    .store-content {\r\n        padding: 15px;\r\n    }\r\n\r\n    .metrics-bar {\r\n        flex-wrap: wrap;\r\n        gap: 8px;\r\n    }\r\n\r\n    .chart-container {\r\n        height: 200px;\r\n    }\r\n}\r\n\r\n.scroll-x {\r\n    overflow-x: auto;\r\n    white-space: nowrap;\r\n}\r\n.scroll-x .tab {\r\n    display: inline-block;\r\n    margin-right: 8px;\r\n}\r\n.app-title {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-weight: bold;\r\n    font-size: 16px;\r\n}\r\n\r\n.app-icon {\r\n    width: 24px;\r\n    height: 24px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
